import type { CustomField } from "@/schema"
import type { SearchResult } from "@/schema/search"

import { CROSS_REFERENCE_TARGET_OPTIONS } from "@/components/settings/custom-fields/constants"

const BACKEND_TARGET_TYPES = CROSS_REFERENCE_TARGET_OPTIONS.map((option) => option.value)
export type BackendTargetType = (typeof BACKEND_TARGET_TYPES)[number]

const BACKEND_TO_SEARCH_TYPE_MAP: Record<BackendTargetType, SearchResult["type"][]> = {
  Household: ["household", "client", "prospect"],
  Business: ["business"],
  User: ["user"],
  Person: ["person"],
  Contact: ["contact"],
}

export const SEARCH_TYPE_TO_BACKEND_TYPE: Partial<Record<SearchResult["type"], BackendTargetType>> = {
  household: "Household",
  client: "Household",
  prospect: "Household",
  business: "Business",
  user: "User",
  person: "Person",
  contact: "Contact",
}

const normalizeBackendTargetType = (type: string | null | undefined): BackendTargetType | undefined =>
  type ? BACKEND_TARGET_TYPES.find((allowed) => allowed.toLowerCase() === type.toLowerCase()) : undefined

export function allowedRelationshipTargetTypes(customField?: CustomField): BackendTargetType[] {
  const configured =
    customField?.cross_reference_allowed_target_types ?? customField?.options?.cross_reference_allowed_target_types
  if (!configured) return BACKEND_TARGET_TYPES

  const normalized = configured.map(normalizeBackendTargetType)
  return BACKEND_TARGET_TYPES.filter((type) => normalized.includes(type))
}

export function allowedRelationshipSearchTypes(customField?: CustomField): SearchResult["type"][] {
  return Array.from(
    new Set(allowedRelationshipTargetTypes(customField).flatMap((type) => BACKEND_TO_SEARCH_TYPE_MAP[type]))
  )
}
